var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertaLaudos)?_c('el-alert',{staticClass:"mb-3 px-4 alerta-usuario-laudos",attrs:{"title":_vm.$t("mensagens.home.usuarioLaudos.alerta"),"type":"warning","closable":true,"show-icon":""},on:{"close":function($event){return _vm.$emit("closeAlerta")}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }